export default "__VITE_ASSET__Dsz8o$Ow__"